const __default__ = {
  head: {
    title: () => ({
      inner: "QR Code"
    }),
    meta: []
  }
};
import { ref, computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import { getDataByPostMethod } from "@/services/axios";
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'QrGen',

  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const school = computed(() => store.state.school);
    const isLoading = ref(true);
    const isShowNotice = ref(false);
    const isShowError = ref(false);
    const qrUrlList = ref([]);

    const createQrData = async () => {
      try {
        const data = await getDataByPostMethod("writer/write_participant_qrcode", {
          belonging: route.params.belong,
          participant_count: route.params.number
        }); // participantの時はqueryにpをつける

        qrUrlList.value = data.item.map(v => {
          return {
            url: process.env.VUE_APP_GUARDIAN_APP_URL + "/entry/" + v.id + "?p=1",
            expire: v.expire_on
          };
        });
      } catch {
        isShowError.value = true;
      } finally {
        isLoading.value = false;
      }
    }; // created


    if (route?.params?.number) {
      createQrData();
    } else {
      isLoading.value = false;
      isShowNotice.value = true;
    }

    return {
      __sfc: true,
      route,
      store,
      school,
      isLoading,
      isShowNotice,
      isShowError,
      qrUrlList,
      createQrData,
      moment
    };
  }

});